import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  carrierCredentialHealthApi,
  type CarrierProvider,
} from '@/services/api/carrier-credential-health';

const QUERY_KEY = ['carrierCredentialHealth'];

export const useCarrierCredentialHealth = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => carrierCredentialHealthApi.get(),
    staleTime: 5 * 60 * 1000,
  });
};

export const useSetCarrierCredentialCheck = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      provider,
      checkEnabled,
    }: {
      provider: CarrierProvider;
      checkEnabled: boolean;
    }) => carrierCredentialHealthApi.setCheckEnabled(provider, checkEnabled),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
};
